import { render } from "./OneCountry.vue?vue&type=template&id=20709474"
import script from "./OneCountry.vue?vue&type=script&lang=js"
export * from "./OneCountry.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__